export default __webpack_public_path__ + "static/media/slide4.6bb8ec95.jpg";